var React = require('react');

function Tooltip (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 .056C4.94.056.833 4.162.833 9.222c0 5.06 4.107 9.167 9.167 9.167s9.167-4.107 9.167-9.167S15.06.056 10 .056zm.917 15.583H9.083v-1.833h1.834v1.833zm1.897-7.104l-.825.843c-.66.67-1.072 1.22-1.072 2.594H9.083v-.458a3.69 3.69 0 0 1 1.073-2.594l1.136-1.155c.34-.33.541-.789.541-1.293A1.839 1.839 0 0 0 10 4.64a1.839 1.839 0 0 0-1.833 1.833H6.333A3.666 3.666 0 0 1 10 2.806a3.666 3.666 0 0 1 3.667 3.666c0 .807-.33 1.54-.853 2.063z","fill":"#167711","fillRule":"evenodd"}));
}

Tooltip.defaultProps = {"width":"20","height":"19"};

module.exports = Tooltip;

Tooltip.default = Tooltip;
